import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useAuth } from '../contexts/AuthContext';

const AddCustomer3Modal = ({ open, onClose, onCreated }) => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [currency, setCurrency] = useState('UZS');
  const [loading, setLoading] = useState(false);
  const { token, user } = useAuth();

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch('/api/customer3', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
          'X-Owner-Id': String(user?.ownerId ?? ''),
          'X-Staff-Id': String(user?.staffId ?? ''),
        },
        body: JSON.stringify({ name, phone, currency }),
      });

      if (!response.ok) {
        throw new Error('Failed to create customer3');
      }

      const createdCustomer = await response.json();
      onCreated(createdCustomer);
      setName('');
      setPhone('');
      setCurrency('UZS');
      onClose();
    } catch (error) {
      console.error('Error creating customer3:', error);
      alert('Error creating customer3: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={open} onHide={onClose} centered backdrop={loading ? 'static' : true}>
      <form onSubmit={handleSubmit}>
        <Modal.Header closeButton={!loading}>
          <Modal.Title>Add Customer 3</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">Name</label>
            <input className="form-control" value={name} onChange={e => setName(e.target.value)} disabled={loading} />
          </div>
          <div className="mb-3">
            <label className="form-label">Phone</label>
            <input className="form-control" value={phone} onChange={e => setPhone(e.target.value)} disabled={loading} />
          </div>
          <div className="mb-3">
            <label className="form-label">Currency</label>
            <select className="form-select" value={currency} onChange={e => setCurrency(e.target.value)} disabled={loading}>
              <option value="UZS">UZS</option>
              <option value="USD">USD</option>
            </select>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose} disabled={loading}>Cancel</Button>
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? 'Creating...' : 'Create'}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default AddCustomer3Modal; 